import React, { memo, useEffect, useState } from 'react'
import { Grid } from '@mui/material'

import CustomDialog from '../shared/customDialog/CustomDialog'
import HeadingText from '../shared/text/HeadingText'
import CustomAlert from '../shared/CustomAlert/CustomAlert'
import { formatCurrency, formatCurrencyShort } from '../../util/numbers.helpers'
import { Trans } from 'react-i18next'
import Text from '../shared/text/Text'
import { MAIN_PROFILE_DISPATCH } from '../../store/reducers/main'
import { transWithArgs } from '../../util/validation.helpers'
import { CURRENCIES } from '../../constants/app'

const ClaimPopup = ({
  t,
  onClose,
  onSubmit,
  mainProfile: { error, claimQBXProcessing },
  available,
  dispatchAction
}) => {
  const [prevAvailable, setPrevAvailable] = useState()
  useEffect(() => {
    if (claimQBXProcessing) {
      setPrevAvailable(available)
    }
  }, [claimQBXProcessing])
  const availableValue = claimQBXProcessing ? prevAvailable : available
  const claimQBXError = error[MAIN_PROFILE_DISPATCH.CLAIM_QBX]
  return (
    <CustomDialog
      isForm
      title={t('home.claim-your')}
      description={t('home.claim-desc')}
      open
      onClose={onClose}
      cancelProps={{
        label: t('common.cancel'),
        autoWidth: true
      }}
      submitProps={{
        label: t('home.unstake-claim'),
        disabled: claimQBXProcessing,
        autoWidth: true
      }}
      body={
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <HeadingText
              label={`${formatCurrencyShort(availableValue)} ${CURRENCIES.DEFAULT}`}
              isLargeFont
              helpText={formatCurrency(availableValue)}
            />
          </Grid>
          <Grid item xs={12}>
            <Text
              variant='body1'
              label={<Trans i18nKey='home.claimed-note' />}
            />
          </Grid>
          {(claimQBXProcessing || claimQBXError) && (
            <Grid item xs={12}>
              <CustomAlert
                info={claimQBXProcessing && t('home.transaction-processing')}
                error={claimQBXError && transWithArgs(t, claimQBXError)}
                onTimeOut={
                  claimQBXProcessing
                    ? () => {
                        dispatchAction(
                          MAIN_PROFILE_DISPATCH.CLAIM_QBX_PROCESSING,
                          false
                        )
                      }
                    : null
                }
              />
            </Grid>
          )}
        </Grid>
      }
      onSubmit={onSubmit}
      t={t}
    />
  )
}

export default memo(ClaimPopup)
